// extracted by mini-css-extract-plugin
module.exports = {"add-button":"AdminView_add-button__2WsF7","button-icon":"AdminView_button-icon__3Mpct","avatar":"AdminView_avatar__1yzJs"};